export default "__VITE_ASSET__b5ecba24__"